function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7017",
  "data-name": "Path 7017",
  d: "M12.411,16.464H9.879v1.5h2.532c.753,0,1.338.384,1.338.715v6.663c0,.331-.584.716-1.338.716H2.84c-.753,0-1.337-.385-1.337-.716V18.683c0-.331.584-.716,1.337-.716H5.372v-1.5H2.84c-1.592,0-2.84.974-2.84,2.218v6.663c0,1.244,1.247,2.218,2.84,2.218h9.572c1.592,0,2.84-.974,2.84-2.218V18.683C15.251,17.438,14,16.464,12.411,16.464Z",
  transform: "translate(0 -12.37)",
  fill: "#7d7d7d"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_7018",
  "data-name": "Path 7018",
  d: "M23.82,7.351a.749.749,0,0,0-.531.22l-.941.94V.868a.751.751,0,0,0-1.5,0V8.562l-.991-.991a.751.751,0,1,0-1.062,1.062l2.243,2.243a.748.748,0,0,0,.531.22h.011a.747.747,0,0,0,.531-.22l2.243-2.243a.751.751,0,0,0-.531-1.282Z",
  transform: "translate(-13.921 -0.117)",
  fill: "#7d7d7d"
});

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "import",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.252,
    height: 15.193,
    viewBox: "0 0 15.252 15.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.d8b1b757.svg";
export { ForwardRef as ReactComponent };